export const setToken = (token) => {
    localStorage.setItem("token", token);
    document.cookie = `token=${token}; path=/; SameSite=Lax;`;
};

export const removeToken = () => {
    localStorage.removeItem("token");
    document.cookie = "token=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC; SameSite=Lax;";
};

export const getToken = () => {
    const token = localStorage.getItem("token");
    if (token && token !== "null" && !document.cookie.includes("token=")) {
        document.cookie = `token=${token}; path=/; SameSite=Lax;`;
    }
    return token;
};
